import React, { useState } from 'react'
import Title from 'shared/components/Title'

import { EmailInput } from 'components/EmailInput'

import { Link } from 'react-router-dom'
import useAxios from 'hooks/useAxios'
import ErrorSSO from './ErrorSSO'
import Page from 'shared/components/Page'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import { Form, Button, Container, Divider, Icon } from 'semantic-ui-react'

export const LoginSSO = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const { fetch: callLoginSSO, loading } = useAxios({
    method: 'POST',
    url: 'sso/login/',
    headers: {
      Authorization: '',
      'X-Workspace-Token': '',
    },
    skip: true,
  })

  const isEmailValid = (value) => {
    const format = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i
    if (format.test(value)) {
      return true
    } else {
      return false
    }
  }

  function submitLogin() {
    setError(false)
    if (isEmailValid(email)) {
      callLoginSSO({
        data: {
          email,
        },
      })
        .then((res) => {
          window.location.href = res.data.url
        })
        .catch((error) => {
          setError(true)
          if (error.response.status === 404) {
            setErrorMessage(
              "Account not found. Please verify your email address or contact your organization's administrator for access to Simplesat."
            )
          } else if (error.response.status === 403 || error.response.status === 400) {
            setErrorMessage('sso_config')
          } else {
            setErrorMessage(
              'Something went wrong. Please try again or contact Simplesat support for help.'
            )
            console.error('error while sso login ', error)
          }
        })
    }
  }

  return (
    <Page>
      <Title title="SSO log in" />
      <AuthenticationShell
        headerText="SSO log in"
        subHeaderText="Log in with your SSO credentials."
      >
        {error && <ErrorSSO message={errorMessage} />}
        <Form onSubmit={submitLogin}>
          <Form.Field>
            <label>Email</label>
            <EmailInput value={email} onChange={setEmail} />
          </Form.Field>

          <Button primary fluid onClick={submitLogin} disabled={loading}>
            Log in
          </Button>
        </Form>
        <Container textAlign="center">
          <Divider hidden />
          <Link to={{ pathname: '/login/', search: location.search }}>
            <Icon className="fas fa-arrow-left" />
            Back to login
          </Link>
        </Container>
      </AuthenticationShell>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/LoginSSO/index.js